export default "__VITE_ASSET__y2CyI4lH8Co64RWy_ES3gQ__"